(() => {
  const popupControllers = new WeakMap();

  const storageGet = (storage, key) => {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const storageSet = (storage, key, value) => {
    try {
      storage.setItem(key, value);
    } catch (error) {
      // Storage can be unavailable in strict privacy modes. The popup remains usable.
    }
  };

  const initB2BWelcome = () => {
    document.querySelectorAll('[data-md-b2b-welcome]').forEach((popup) => {
      if (popup.dataset.mdB2BBound === 'true') return;
      popup.dataset.mdB2BBound = 'true';

      const customerId = popup.dataset.customerId || 'customer';
      const dismissedKey = `md_b2b_welcome_dismissed_${customerId}`;
      const shownKey = `md_b2b_welcome_shown_${customerId}`;
      const closeButton = popup.querySelector('[data-md-b2b-close-button]');
      let previousActiveElement = null;

      const openPopup = ({ automatic = false } = {}) => {
        previousActiveElement = document.activeElement;

        if (automatic) {
          storageSet(window.sessionStorage, shownKey, '1');
        }

        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('md-b2b-welcome-open');

        window.requestAnimationFrame(() => {
          closeButton?.focus({ preventScroll: true });
        });
      };

      const dismissPopup = () => {
        storageSet(window.localStorage, dismissedKey, '1');
        popup.hidden = true;
        popup.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('md-b2b-welcome-open');

        if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
          previousActiveElement.focus({ preventScroll: true });
        }
      };

      popup.querySelectorAll('[data-md-b2b-close]').forEach((control) => {
        control.addEventListener('click', dismissPopup);
      });

      popup.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !popup.hidden) {
          event.preventDefault();
          dismissPopup();
        }
      });

      popupControllers.set(popup, { openPopup });

      const wasDismissed = storageGet(window.localStorage, dismissedKey) === '1';
      const shownThisSession = storageGet(window.sessionStorage, shownKey) === '1';

      if (!wasDismissed && !shownThisSession) {
        openPopup({ automatic: true });
      }
    });
  };

  const bindManualOpeners = () => {
    if (document.documentElement.dataset.mdB2BOpenersBound === 'true') return;
    document.documentElement.dataset.mdB2BOpenersBound = 'true';

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-md-b2b-open]');
      if (!opener) return;

      const popup = document.querySelector('[data-md-b2b-welcome]');
      const controller = popup ? popupControllers.get(popup) : null;
      if (!controller) return;

      event.preventDefault();
      controller.openPopup({ automatic: false });
    });
  };

  const init = () => {
    initB2BWelcome();
    bindManualOpeners();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', initB2BWelcome);
})();
